import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AmorphicService } from '../../../angular/services/amorphic/amorphic.service';
import { CoverpathControllerInterface } from '../../../angular/interfaces/controller/CoverpathControllerInterface';
import { ApplicationTypes } from '../../interfaces/CoverpathTypes';

const UNAUTHORIZED_ROUTE = 'unauthorized';

@Injectable()
export class ActiveApplicationGuard implements CanActivate {
  controller: CoverpathControllerInterface;

  constructor(private router: Router, readonly amorphicService: AmorphicService) {
    this.controller = amorphicService.controller;
  }

  async canActivate(): Promise<boolean> {
    const application = this.controller.customer.application;
    if (application) {
      // @TODO refactor when HL-21333 is done
      const hasAccess = await this.controller.checkApplicationAccess(application).catch(() => false);
      if (hasAccess) {
        return true;
      }
    }

    this.router.navigate([UNAUTHORIZED_ROUTE], {
      queryParams: { wasCancelled: application && application.type !== ApplicationTypes.ACTIVE },
    });
    return false;
  }
}
